"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    responseHandlerPlugin: ()=>responseHandlerPlugin
});
const external_tool_js_namespaceObject = require("../../tool.js");
const responseHandlerPlugin = function() {
    let { errorCodeKey = 'error_code' } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return {
        response: [
            (response)=>{
                var _response_config_pluginConfig, _response_config;
                const { data } = response;
                if ('number' == typeof (null == data ? void 0 : data[errorCodeKey]) && data[errorCodeKey] && !(null == response ? void 0 : null == (_response_config = response.config) ? void 0 : null == (_response_config_pluginConfig = _response_config.pluginConfig) ? void 0 : _response_config_pluginConfig.responseHandlerDisabled)) return Promise.reject(Object.assign(new external_tool_js_namespaceObject.CommonLibError('ResponseHandlerPlugin', 'ErrorCode is non-zero '), {
                    config: response.config,
                    response
                }));
                return response;
            }
        ]
    };
};
exports.responseHandlerPlugin = __webpack_exports__.responseHandlerPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "responseHandlerPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
